var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading && _vm.loaded)?_c('div',{staticClass:"grade_item-container"},[_c('h2',{staticClass:"grade_item-name"},[_vm._v("Аналитика прохождения заданий")]),_c('div',{staticClass:"chart"},[_c('apexchart',{attrs:{"type":"bar","height":"460","options":_vm.options,"series":_vm.series}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }